<template lang="pug">
BaseModal.ModalLogin.modal-login.is--small(
  :value="value"
  size="small"
  @close="onCancel"
)
  h3.modal-login__title Log In
  FormLogin.modal-login__form(
    @success="onSuccess"
    :on-sign-up-redirect="onSignUpRedirect"
  )
</template>

<script>
import FormLogin from 'Components/FormLogin/FormLogin';
import BaseModal from 'Components/Base/BaseModal';

export default {
  name: 'ModalLogin',
  components: {
    FormLogin,
    BaseModal,
  },
  props: {
    value: Boolean,
    onSignUpRedirect: String,
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess(loginData) {
      this.$emit('success', loginData);
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.modal-login
  &.is--small
    ::v-deep
      .modal__container
        display: flex
        flex-direction: column
        background-color: $gray-10
        max-width: 410px
        max-height: 100%
        @media screen and (max-height: 609px) and (orientation: landscape)
          height: 90vh !important
          max-height: 609px
        @media screen and (max-width: 767px) and (orientation: portrait)
          max-height: 100%
      .modal__content
        margin: 0
        & .login-form__fields
          padding: 10px
  &__title
    text-align: center
    margin-bottom: 20px
    font-size: 20px
    line-height: 28px
</style>
